/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Headset(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M233.45605,128v80a40.04551,40.04551,0,0,1-40,40H136a8,8,0,0,1,0-16h57.45605a24.0275,24.0275,0,0,0,24-24v-1.376a23.89418,23.89418,0,0,1-8,1.376h-16a24.0275,24.0275,0,0,1-24-24V144a24.0275,24.0275,0,0,1,24-24h23.64454a88.01738,88.01738,0,0,0-88.31348-79.99756c-.041.00049-.07813.00049-.11914,0A88.01928,88.01928,0,0,0,40.35547,120H64a24.0275,24.0275,0,0,1,24,24v40a24.0275,24.0275,0,0,1-24,24H48a24.0275,24.0275,0,0,1-24-24V128A104.00025,104.00025,0,0,1,128.72754,24.00244c.24414-.00146.49121-.00244.73535-.00244A104.00007,104.00007,0,0,1,233.45605,128Z" />
    </Svg>
  );
}

export default Headset;
